import { Component, OnInit } from '@angular/core';
import {ArticleVM} from "../../../model/viewModel/article.vm";
import {ArticleService} from "../../../service/article.service";
import {ActivatedRoute, Router} from "@angular/router";
import {delay, switchMap} from "rxjs";
import {TitleWrapperService} from "../../../service/title-wrapper.service";
import {TranslationService} from "../../../service/translation.service";

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  data: ArticleVM | undefined = undefined;
  constructor(
    private articleService: ArticleService,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleWrapperService,
    private translationService: TranslationService,
  ) { }

  ngOnInit(): void {
    this.updateTitle();
    this.activatedRoute.params.pipe(switchMap(params => {
      return this.articleService.getArticleById(params["id"])
    })).subscribe(article => {
      this.data = article;
      this.updateTitle();
    });
  }

  private updateTitle(){
    const basePageName = this.translationService.trans("article.page_title", "Article");
    if(this.data){
      this.titleService.setPageName(
        `${basePageName} - ${this.data.title}`
      );
    }else{
      this.titleService.setPageName(basePageName);
    }
  }

}
